module.exports = __webpack_public_path__ + "static/media/hero-crowd-heart.0e65b517.jpg";